import * as React from "react";

const DealsShown: React.FC<{ viewableDeals: number; totalDeals: number }> = ({
	viewableDeals,
	totalDeals,
}) => {
	return (
		<span>
			Showing {viewableDeals} of {totalDeals} deals
		</span>
	);
};

export default DealsShown;
